import ScoreboardPage from '@/modules/dashboard/ranking/scoreboard-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/ranking/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ScoreboardPage className="page-container" />;
}
